import { render, staticRenderFns } from "./LossCurves.vue?vue&type=template&id=51794a71&scoped=true&"
import script from "./LossCurves.vue?vue&type=script&lang=js&"
export * from "./LossCurves.vue?vue&type=script&lang=js&"
import style0 from "./LossCurves.vue?vue&type=style&index=0&id=51794a71&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51794a71",
  null
  
)

export default component.exports